// src/components/Button.js
import React from 'react';

const Button = ({ onClick, children }) => {
  return (
    <button
      onClick={onClick}
      className="bg-[#ED213A] hover:bg-[#93291E] active:bg-[#93291E] text-l text-slate-50 px-4 rounded justify-center"
    >
      {children}
    </button>
  );
};

export default Button;